import axios from "axios";
import { useState } from "react";
import { Button } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
export default function SetupForm() {
  const { code } = useParams();

  const decodeBase64UrlSafe = (encoded: string | undefined) => {
    if (encoded == null) return encoded;
    // Revertir los cambios URL-safe
    const base64 = encoded.replace(/-/g, "+").replace(/_/g, "/");
    return decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join(""),
    );
  };

  const { list } = useParams<{ list: string }>();
  const { api } = useParams<{ api: string }>();
  const { user } = useParams<{ user: string }>();
  const [lista, setLista] = useState(decodeBase64UrlSafe(list));
  const [apiKey, setApiKey] = useState(decodeBase64UrlSafe(api));
  const [usuario, setUsuario] = useState(decodeBase64UrlSafe(user));
  const [message, setMessage] = useState("");
  const handleSubmit = async (e: any) => {
    e.preventDefault();

    // Validar campos
    if (!lista || !apiKey || !usuario) {
      setMessage("Todos los campos son obligatorios.");
      return;
    }

    try {
      axios
        .post(
          `${
            process.env.NODE_ENV === "development"
              ? "http://localhost:5500"
              : "https://ligavirtualf1.es:5500"
          }/api/xuxaweatv/sendForm`,
          {
            lista,
            apiKey,
            usuario,
            code,
          },
        )
        .then(({ data }) => {
          toast.success("Datos guardados correctamente");
        })
        .catch(({ response }) => {
          toast.error("Error al enviar datos");
          throw new Error(response);
        });
    } catch (err) {
      console.error(err);
      setMessage("Error de conexión con el servidor.");
    }
  };

  return (
    <div
      style={{
        maxWidth: "400px",
        margin: "50px auto",
        fontFamily: "sans-serif",
        marginTop: "80px",
      }}
    >
      <h2 className="text-center">Configurar XUXAWEA TV</h2>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: "10px" }}>
          <label>Lists IPTV:</label>
          <input
            type="text"
            className="form form-control"
            value={lista}
            onChange={(e) => setLista(e.target.value)}
            style={{ width: "100%", padding: "6px", marginTop: "4px" }}
          />
        </div>
        <div style={{ marginBottom: "10px" }}>
          <label>TMBD API Key:</label>
          <input
            type="text"
            className="form form-control"
            value={apiKey}
            onChange={(e) => setApiKey(e.target.value)}
            style={{ width: "100%", padding: "6px", marginTop: "4px" }}
          />
        </div>
        <div style={{ marginBottom: "10px" }}>
          <label>Usuario XuxaweaTV:</label>
          <input
            type="text"
            className="form form-control"
            value={usuario}
            onChange={(e) => setUsuario(e.target.value)}
            style={{ width: "100%", padding: "6px", marginTop: "4px" }}
          />
        </div>
        <div className="text-center">
          <Button variant="primary" type="submit">
            Enviar
          </Button>
        </div>
      </form>
      {message && <p style={{ marginTop: "10px" }}>{message}</p>}
    </div>
  );
}
